import dynamic from 'next/dynamic';

const Video = dynamic(() => import('@components/Video'), { ssr: false });

export interface GalleryVideoProps {
  videoData: string;
}

import { FC } from 'react';
import { ModalInnerWrapper } from './styles';

const GalleryVideo: FC<GalleryVideoProps> = ({ videoData }) => {
  return (
    <ModalInnerWrapper>
      <Video youTubeUrl={videoData} video_source controls />
    </ModalInnerWrapper>
  );
};

export default GalleryVideo;
